import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import DisconnectIcon from '@mui/icons-material/LinkOff';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import favicon from '../assets/favicon.png';
import { WalletDisconnectButton, WalletMultiButton } from '@solana/wallet-adapter-material-ui';
import { Link } from "react-router-dom";

const ResponsiveAppBar: React.FC<{ walletConnected: boolean }> = ({ walletConnected }) => {

  return (
    <AppBar position="static" sx={{ mb: 6}}>
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ display: 'flex'}}>
          <Box component="img" src={favicon} sx={{ mr: 1, height: 32, width: 32 }} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              color: 'inherit',
              textDecoration: 'none',
              flexGrow: 1
            }}
          >
            bokoup
          </Typography>

          <Box sx={{ flexGrow: 0 }}>
          <WalletMultiButton />
                {walletConnected && (
                    <WalletDisconnectButton startIcon={<DisconnectIcon />} style={{ marginLeft: 8 }} />
                )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;
